export default { // 该需求运行在评估师app - 我的工单 - 左上角入口
  tabs: [
    {
      name: 'followTask',
      path: '/followTask',
      component: () => import('./src/pages/followTask.vue'),
      meta: {
        title: '跟进任务',
        isMenu: true,
      }
    }
  ]
}
